;(function () {
    /**
     *
     * [data-countdown-end] accepts either a datetime in the format YYYY-MM-DDTHH:mm:ss+10:00
     * or a literal string with with word minutes for an evergreen timer like "15 minutes" or "45 minutes"
     *
     */
    var countdownElements = document.querySelectorAll('[data-countdown-end]')

    countdownElements.forEach((el, index) => {
        if (el.dataset.countdownEnd.indexOf('minutes') > -1) {
            // Assuming el.dataset.countdownEnd contains the string representing X minutes (e.g., '15 minutes')
            let countdownMinutes = parseInt(
                el.dataset.countdownEnd.replace(' minutes', '')
            )
            let currentDate = new Date()
            let currentMinutes = currentDate.getMinutes()

            let nearestBlock =
                Math.ceil(currentMinutes / countdownMinutes) * countdownMinutes

            if (nearestBlock >= 60) {
                nearestBlock = 0
                currentDate.setHours(currentDate.getHours() + 1)
            }

            if (nearestBlock !== currentMinutes) {
                currentDate.setMinutes(nearestBlock, 0, 0)
            } else {
                currentDate.setMinutes(nearestBlock + countdownMinutes, 0, 0)
            }

            countdown(currentDate, el)
        } else {
            var endDate = new Date(el.dataset.countdownEnd)
            countdown(endDate, el)
        }
    })

    function countdown(endDate, element) {
        const daysSpan = element.querySelector('.days')
        const hoursSpan = element.querySelector('.hours')
        const minutesSpan = element.querySelector('.minutes')
        const secondsSpan = element.querySelector('.seconds')
        let timerInterval

        function updateTimer() {
            const timeRemaining = Date.parse(endDate) - Date.parse(new Date())

            const days = padZero(
                Math.floor(timeRemaining / (1000 * 60 * 60 * 24))
            )
            const hours = padZero(
                Math.floor((timeRemaining / (1000 * 60 * 60)) % 24)
            )
            const minutes = padZero(
                Math.floor((timeRemaining / 1000 / 60) % 60)
            )
            const seconds = padZero(Math.floor((timeRemaining / 1000) % 60))

            daysSpan.innerHTML = days
            hoursSpan.innerHTML = hours
            minutesSpan.innerHTML = minutes
            secondsSpan.innerHTML = seconds

            if (timeRemaining <= 0) {
                daysSpan.innerHTML = '00'
                hoursSpan.innerHTML = '00'
                minutesSpan.innerHTML = '00'
                secondsSpan.innerHTML = '00'

                clearInterval(timerInterval)
            }
        }

        updateTimer()
        timerInterval = setInterval(updateTimer, 1000)
    }

    function padZero(value) {
        return value < 10 ? `0${value}` : value
    }
})()
